import React, {useState} from "react";
import { FaLinkedin, FaGithub, FaTwitter } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBowlFood, faCode, faBed } from "@fortawesome/free-solid-svg-icons";

function Home({setActiveSection}) {
 
  return (
    <section id="#home">
    <div className="flex justify-center items-center min-h-screen ">
      <div className="bg-white bg-opacity-100 p-8 rounded-lg shadow-lg w-full md:w-[800px] card project-card">
        <h1 className="text-4xl md:text-6xl font-bold mb-2 md:mb-4">
          Kaung Sett Lwin
        </h1>
        <p className="text-xl md:text-4xl text-black-800 mb-4 md:mb-6 font-bold running-text">
          Passionate Software Developer
        </p>
        <p className="text-md md:text-2xl text-white-800 mb-4 md:mb-6 font-bold running-text">
          I choose to be stuck in the{" "}
          <span className="running-text">
            <span></span>
            <FontAwesomeIcon
              icon={faBowlFood}
              style={{ color: "#92400e" , marginLeft: '10px',}}
              className="inline-block md:text-xl"
            />
            <span></span>
            <FontAwesomeIcon
              icon={faBed}
              style={{ color: "#dc2626" , marginLeft: '10px'}}
              className="inline-block md:text-xl wave-animation"
            />
            <span></span>
            <FontAwesomeIcon
              icon={faCode}
              style={{ color: "#991b1b" ,marginLeft: '10px'}}
              className="inline-block md:text-xl wave-animation"
            />
            <span style={{marginLeft: '10px'}}></span>
            loop.
          </span>
        </p>
        <div className="flex justify-center space-x-6 wave-animation">
          <a
            href="https://www.linkedin.com/in/kaung-sett-lwin-661376274/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="text-2xl text-blue-600 hover:text-blue-800 cursor-pointer"/>
          </a>
          <a
            href="https://github.com/kaungSethLwin"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub className="text-2xl text-gray-600 hover:text-gray-800 cursor-pointer" />
          </a>
          <a
            href="https://twitter.com/sett39560"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter className="text-2xl text-blue-400 hover:text-blue-600 cursor-pointer" />
          </a>
        </div>
        <div className="mt-8 flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4">
          <a
            href="https://drive.google.com/file/d/1mg7uByO_IWQOFMlgm7_ErEPdESE-A0oh/view?usp=drive_link"
            download
          >
            <button className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
              Download my CV
              <span className="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </span>
            </button>
          </a>
          <a href="#about">
            <button
             onClick={() => setActiveSection("about")}
            className="flex items-center px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
              Go to the About Page
              <span className="ml-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </span>
            </button>
          </a>
        </div>
      </div>
    </div>
    </section>
  );
}

export default Home;
